import { faSparkles } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, Menu, SxProps, Tooltip, useTheme } from '@mui/material';
import React, { PropsWithChildren, useState } from 'react';

type IAMenuProps = {
    sxProps?: SxProps;
};

const IAMenu: React.FunctionComponent<PropsWithChildren<IAMenuProps>> = function ({
    sxProps,
    children,
}) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const { palette } = useTheme();

    return (
        <Box
            onKeyDown={() => {}}
            role="button"
            tabIndex={0}
            sx={sxProps}
        >
            <Tooltip
                key="menu-ia"
                title="Outils IA"
            >
                <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-controls={open ? 'long-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                    sx={{
                        borderRadius: '50%',
                        height: '40px',
                        width: '40px',
                        boxShadow: `0px 2px 2.5px 0px ${palette.grey[200]}`,
                        backgroundColor: palette.primary.dark,
                        color: palette.common.white,
                        transition: 'all ease-in-out 300ms',
                        '&:hover': {
                            backgroundColor: palette.primary.main,
                        },
                    }}
                >
                    <FontAwesomeIcon
                        icon={faSparkles}
                        fontSize="1rem"
                    />
                </IconButton>
            </Tooltip>
            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                        paddingX: '4px',
                    }}
                >
                    {children}
                </Box>
            </Menu>
        </Box>
    );
};

export default IAMenu;
